var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.664,
    height: 32.658,
    viewBox: "0 0 35.664 32.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{stroke:#fff;}.a{stroke-linecap:round;}.b{fill:none;stroke-miterlimit:10;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.169 -4.403)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M207.607,206.61",
    transform: "translate(-198.302 -187.088)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.852 5.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M216.507,128.067l-8.9,5.138v10.277l8.9,5.138,8.9-5.138V133.205Z",
    transform: "translate(-199.173 -117.223)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 5.185,
    x2: 8.981,
    transform: "translate(6.911 8.316)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 7.012,
    x2: 12.145,
    transform: "translate(3.684 4.494)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 8.957,
    x2: 15.515,
    transform: "translate(0 0.057)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 8.981,
    y2: 5.185,
    transform: "translate(18.607 8.382)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 12.145,
    y2: 7.012,
    transform: "translate(18.466 4.439)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 15.515,
    y2: 8.957,
    transform: "translate(18.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M213.753,128.067l-6.146,3.548v7.1l6.146,3.548,6.146-3.548v-7.1Z",
    transform: "translate(-196.413 -113.779)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.fd32a597a767ed3fd6976b358d7e62d8.svg";
export { ForwardRef as ReactComponent };